import type { APIParams } from '@/store/helpers/types';
import { Paths } from '../constants';
import type {
  LoadPolicyResponse,
  PeopleAccess,
  PeopleRoleKey,
} from '@/shared/types/policy';
import type { ISOTimestampString } from '@/shared/types/common';
import { apiInvoke } from '@/store/helpers/load';
import { makePayloadRequestInit } from '@/lib/api';
import { type AccessStore } from '.';

export async function loadPolicy(
  { dispatch }: AccessStore,
  { api, auth }: APIParams,
) {
  const path = `${Paths.policy}/people`;
  const res = await apiInvoke<LoadPolicyResponse>(api, path, auth);
  if (res.exists) {
    dispatch({ type: 'setAccessPolicy', data: res.data });
  }

  return res;
}

export async function updatePolicy(
  { dispatch }: AccessStore,
  {
    api,
    auth,
    data,
  }: APIParams & { data: Record<PeopleRoleKey, PeopleAccess> },
) {
  const path = `${Paths.policy}/people`;
  const res = await apiInvoke<UpdatePolicyResponse>(
    api,
    path,
    auth,
    makePayloadRequestInit(data, 'PATCH'),
  );
  if (res.updated) {
    dispatch({ type: 'setAccessPolicy', data: res.data });
  }

  return res;
}

export type UpdatePolicyResponse = {
  id: string;
  data: {
    data: Record<PeopleRoleKey, PeopleAccess>;
    updated_at?: ISOTimestampString;
    updated_by?: string;
  };
  updated: true;
};
